var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareDelete = function SvgShareDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F55060",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M13.287 15.55c-5.968 0-8.889 2.834-8.889 6.33 0 .556.406 1.007.907 1.007h7.982m3.334-14.444a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0ZM24 22.5l-3-3m0 0-3-3m3 3-3 3m3-3 3-3"
  })));
};
export default SvgShareDelete;